import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { isBefore } from 'date-fns';

export const dateSinceAfterNowValidator =
  (required = true): ValidatorFn =>
  (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return required ? { required: { message: 'error.required_date' } } : null;
    }

    const selectedDate = new Date(control.value);
    const now = new Date();

    if (isBefore(selectedDate, now)) {
      return { dateBeforeNow: { message: 'error.date_before_now' } };
    }

    // if (isToday(selectedDate)) {
    //   return { timeBeforeNow: { message: 'error.time_before_now' } };
    // }

    return null;
  };
